import {Component, computed, inject} from '@angular/core';
import {LayoutService} from '@/layout/service/layout.service';

@Component({
    selector: '[app-footer]',
    standalone: true,
    template: `
        <div class="layout-footer">
                <img  src="assets/sigos-images/logo.png" alt="sigosLogo" width="80px" />

            <span class="footer-copyright">&#169; MaxProcess 2025. Solução SIGOS. Todos os direitos reservados.</span>
        </div>
    `
})
export class AppFooter {
    layoutService = inject(LayoutService);

    isDarkTheme = computed(() => this.layoutService.isDarkTheme());
}
